import { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import serviceRequest from "utils/request";
import { UserContext } from "./UserContext";
import { getUserInfo, newLogin } from "api/index";
import { rsaOaepEncrypt } from "utils/encrypt";

export default function useAuth(handleFirstLogin) {
	let history = useHistory();
	const { setUser } = useContext(UserContext);
	const [error, setError] = useState(null);
	//set user in context and push them home
	const setUserContext = async () => {
		return await getUserInfo()
			.then((res) => {
				setUser(res.data);
				sessionStorage.setItem("DATA_SERVICES_USER", JSON.stringify(res.data));
				const HOMEPAGE = res.data?.homePage ?? "/homepage";
				history.push(HOMEPAGE);
			})
			.catch((err) => {
				console.error(err);
				if (err.response) {
					setError(err.response.data);
				}
			});
	};
	const newLoginUser = async (data) => {
		const { username, password } = data;
		const sha256pwd = await rsaOaepEncrypt(password);

		return newLogin({
			username,
			password: sha256pwd,
		}).then(async (res) => {
			const token = res.data.accessToken;
			serviceRequest.defaults.headers.common["Authorization"] = `Bearer ${token}`;
			sessionStorage.setItem("accessToken", token);
			sessionStorage.setItem("refreshToken", res.data.refreshToken);
			sessionStorage.setItem("lastLoginTime", res.data.lastLoginTime);

			//console.log("login res", res);
			if (res.data?.needResetPwd) {
				handleFirstLogin("Please reset your password.");
			} 
			else if (res.data?.needChangePwd) {
				handleFirstLogin("Your password has expired.\nPlease change your password.");
			} else {
				await setUserContext();
			}
		});
	};

	return {
		// loginUser,
		error,
		newLoginUser,
	};
}
